export default "__VITE_ASSET__CJ84LtJJ__"